'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.species.js
// module id = 614
// module chunks = 0